import type { IMetaV2 } from "../../../types/models/meta-v2"

export type {
  IMeanTeam,
  IMetaV2,
  ITopTeam
} from "../../../types/models/meta-v2"

export async function fetchMetaV2(): Promise<IMetaV2[]> {
  return fetch(`/meta-v2?t=${new Date().getUTCDate()}`).then((res) => res.json())
}
